import { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react"

export const StickyNavigation = forwardRef(({
  items,
  heroHeight = 500,
  navHeight = 60,
  stickyNavHeight = 96,
  className = "",
  itemClassName = "",
  activeItemClassName = "",
  containerClassName = "",
  onScrollToSection
}, ref) =>  {
  const [isSticky, setIsSticky] = useState(false)
  const [activeTab, setActiveTab] = useState(1)
  const sectionRefs = useRef({})

  const scrollToSection = (tabNumber, name) => {
    if (name === 'Coming soon' || name === '') {
        return;
    }
    const section = sectionRefs.current[tabNumber]
    if (section) {
      const offset = navHeight + stickyNavHeight + 20 // 额外间距

      const elementPosition = section.getBoundingClientRect().top + window.pageYOffset - (isSticky ? 0 : navHeight + 35);
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })

      setActiveTab(tabNumber)
    }
  }

  useImperativeHandle(ref, () => ({
    scrollToSection: (tabNumber, name) => scrollToSection(tabNumber, name)
  }))

  useEffect(() => {
    if (onScrollToSection) {
      onScrollToSection(scrollToSection);
    }
  }, [onScrollToSection]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollOffset = navHeight + stickyNavHeight + 100

      if (window.scrollY >= heroHeight - navHeight) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }

      // 检测当前可见的部分
      Object.entries(sectionRefs.current).forEach(([key, ref]) => {
        if (ref) {
          const rect = ref.getBoundingClientRect()
          if (rect.top <= scrollOffset && rect.bottom >= scrollOffset) {
            setActiveTab(Number.parseInt(key))
          }
        }
      })
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [heroHeight, navHeight, stickyNavHeight])

  const setSectionRef = (id) => (el) => {
    sectionRefs.current[id] = el
  }

  // 根据项目数量确定网格类名
  const getGridCols = (count) => {
    switch (count) {
      case 1:
        return "grid-cols-1"
      case 2:
        return "grid-cols-2"
      case 3:
        return "grid-cols-3"
      case 4:
        return "grid-cols-4"
      case 5:
        return "grid-cols-5"
      case 6:
        return "grid-cols-6"
      default:
        return "grid-cols-4"
    }
  }

  return (
    <>
      {/* Sticky Navigation Tabs */}
      <div
        className={`${
          isSticky ? "fixed left-0 right-0 z-40 shadow-lg" : "relative"
        } bg-white transition-all duration-300 mx-auto ${className}`}
        style={isSticky ? { top: `${navHeight}px` } : {}}
      >
        <div className={`container mx-auto container-max-w ${containerClassName}`}>
          <div className={`grid ${getGridCols(items.length)} gap-0`}>
            {items.map((item, index) => (
              <div
                key={item.id}
                onClick={() => scrollToSection(item.id, item.title)}
                className={`p-6 hover:bg-[#F3F3F3] cursor-pointer group
                    ${activeTab === item.id ? "bg-[#F3F3F3]" : ""} ${itemClassName} ${
                  activeTab === item.id ? activeItemClassName : ""
                }`}
              >
                <div className="font-titillium">
                  <div className="text-[#4D4D4D]">
                    {item.title ? item.id.toString().padStart(2, "0") : ''}
                  </div>
                  <div>
                    <h3 className="text-[#4D4D4D]">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container container-max-w mx-auto">
        <div>
          {items.map((item) => (
            <section key={item.id} ref={setSectionRef(item.id)} className={`${(item.title === 'Coming soon' || !item.title) && 'hidden'}`}>
              {item.content}
            </section>
          ))}
        </div>
      </div>
    </>
  )
})
